<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :fixed-header="true"
    :disable-pagination="true"
    :loading="$apollo.loading"
    :height="tableHeight"
    :search="search"
    :sort-by="sortBy"
    loading-text="Laddar... var god vänta!"
    no-data-text="Ingen data..."
    no-results-text="Inget resultat på din sökning..."
    hide-default-footer
    @click:row="onClickRow"
  >
    <template v-slot:top>
      <v-dialog v-model="showEditModal" width="500">
        <MasterdataSubCategoriesEdit
          v-if="showEditModal"
          :uuid="edit_uuid"
          @close="
            showEditModal = false
            edit_uuid = null
          "
        />
      </v-dialog>
      <v-toolbar flat>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Sök..."
          single-line
          hide-details
          rounded
          filled
          dense
        ></v-text-field>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer />
        <v-btn @click="exportExcel" rounded class="mr-4">
          Exportera till Excel
          <v-icon small right>mdi-file-export-outline</v-icon>
        </v-btn>
        <v-dialog v-model="showCreateModal" width="500" persistent>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" rounded>
              Lägg till
            </v-btn>
          </template>
          <MasterdataSubCategoriesCreate
            @close="showCreateModal = false"
            v-if="showCreateModal"
          />
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.action="{ item }">
      <v-menu offset-y v-model="item.showMenu">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
            @click="
              showEditModal = true
              edit_uuid = item.uuid
            "
            @mouseup="item.showMenu = false"
          >
            <v-list-item-icon>
              <v-icon>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Redigera</v-list-item-title>
          </v-list-item>
          <v-dialog v-model="showDeleteModal" width="500">
            <template v-slot:activator="{ on }">
              <v-list-item v-on="on" @mouseup="item.showMenu = false">
                <v-list-item-icon>
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Ta bort</v-list-item-title>
              </v-list-item>
            </template>
            <MasterdataSubCategoriesDelete
              :uuid="item.uuid"
              @close="showDeleteModal = false"
              v-if="showDeleteModal"
            />
          </v-dialog>
        </v-list>
      </v-menu>
    </template>
  </v-data-table>
</template>

<script>
import MasterdataSubCategoriesCreate from './MasterdataSubCategoriesCreate'
import MasterdataSubCategoriesDelete from './MasterdataSubCategoriesDelete'
import MasterdataSubCategoriesEdit from './MasterdataSubCategoriesEdit'
import GET_CATEGORIES from '@/gql/categories/queries/GetCategories.gql'
import GET_CATEGORY_GROUPS from '@/gql/categoryGroups/queries/GetCategoryGroups.gql'
import { tableHeight } from '@/mixins/tableHeight'
import { get } from 'vuex-pathify'
import { exportExcel } from '@/services/export-excel-service.js'

export default {
  name: 'MasterdataSubCategories',

  components: {
    MasterdataSubCategoriesCreate,
    MasterdataSubCategoriesDelete,
    MasterdataSubCategoriesEdit,
  },

  mixins: [tableHeight()],

  data() {
    return {
      edit_uuid: null,
      showEditModal: false,
      showDeleteModal: false,
      showCreateModal: false,
      formTitle: 'Underkategorier',
      headers: [
        { text: 'Namn', value: 'name' },
        { text: 'Kategorigrupp', value: 'categoryGroup' },
        { text: '', value: 'action', align: 'right' },
      ],
      search: '',
      sortBy: 'name',
    }
  },

  apollo: {
    categoryGroups: {
      query: GET_CATEGORY_GROUPS,
      manual: true,
      result({ data }) {
        this.$store.set(
          'categoryGroups/data',
          (data.categoryGroups || []).reduce((a, b) => {
            a[b.uuid] = b
            return a
          }, {}),
        )
      },
    },

    categories: {
      query: GET_CATEGORIES,
      manual: true,
      result({ data }) {
        this.$store.set(
          'categories/data',
          ((data && data.categories) || []).reduce((a, b) => {
            a[b.uuid] = b
            return a
          }, {}),
        )
      },
    },
  },

  computed: {
    categories: get('categories/data'),
    categoryGroups: get('categoryGroups/data'),

    items() {
      if (this.$apollo.loading) return []
      return Object.values(this.categories || {}).map(x => ({
        ...x,
        categoryGroup: this.categoryGroups[x.category_group_uuid].name,
        showMenu: false,
      }))
    },
  },

  methods: {
    onClickRow(item) {
      this.edit_uuid = item.uuid
      this.showEditModal = true
    },

    exportExcel() {
      const filename = `Underkategorier`

      const workbook = {
        name: filename,
        sheets: [
          {
            name: 'data',
            data: this.items.map(row => {
              return {
                Namn: row.name,
                Kategorigrupp: row.categoryGroup,
              }
            }),
          },
        ],
      }

      exportExcel(filename, workbook)
    },
  },
}
</script>
